import './BudgetSection.scss';

import { Col, Row } from 'react-bootstrap';
import { useEffect, useState } from 'react';

import AppCurrencyInput from '../../../../commons/inputs/AppCurrencyInput';
import AppDateTimeInput from './AppDateTimeInput';
import AppInput from '../../../../commons/inputs/AppInput';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import InformativeModal from './InformativeModal';
import Select from 'react-select';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

const customStyles = {
    control: (provided) => ({
        ...provided,
        minHeight: 60,
        borderRadius: 10,
        border: '2px solid #e9ecef',
        '&:hover': {
            border: '2px solid #667eea',
        }
    }),
    menu: (provided) => ({
        ...provided,
        zIndex: 9999,
        borderRadius: 10,
        boxShadow: '0 4px 16px rgba(0,0,0,0.1)',
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? '#667eea' : state.isFocused ? '#f8f9fa' : 'white',
        color: state.isSelected ? 'white' : '#2c3e50',
        padding: 12,
        cursor: 'pointer',
    }),
};

const objectiveOptions = [
    { value: 'OUTCOME_AWARENESS', label: 'Reconhecimento da marca', icon: '⭐' },
    { value: 'OUTCOME_TRAFFIC', label: 'Tráfego', icon: '🔗' },
    { value: 'OUTCOME_ENGAGEMENT', label: 'Engajamento', icon: '💬' },
    { value: 'OUTCOME_LEADS', label: 'Geração de Leads', icon: '📋' },
    { value: 'OUTCOME_APP_PROMOTION', label: 'Promoção de App', icon: '📱' },
    { value: 'OUTCOME_SALES', label: 'Vendas / Conversões', icon: '🛒' }
];

function BudgetSection({ values, errors, touched, handleChange, setFieldValue, isEdit }) {
    const [showInfoModal, setShowInfoModal] = useState(false);
    const [currentObjective, setCurrentObjective] = useState(null);
    const [selectedGender, setSelectedGender] = useState('all');

    useEffect(() => {
       setSelectedGender(values?.targetGender)
    }, []);

    const openInfoModal = (objective) => {
        setCurrentObjective(objective);
        setShowInfoModal(true);
    };

    const closeInfoModal = () => {
        setShowInfoModal(false);
        setCurrentObjective(null);
    };

    const handleGenderChange = (gender) => {
        setSelectedGender(gender);
        setFieldValue('targetGender', gender);
    };

    const buildInfoByObjective = () => {
        if (!currentObjective) return null;
    
        switch (currentObjective) {
            case 'OUTCOME_TRAFFIC': // antes LINK_CLICKS
                return (
                    <div className="p-3 border rounded bg-light">
                        <h6 className="fw-bold">🔗 O que é Tráfego (cliques no link)?</h6>
                        <p>
                            Este objetivo é ideal quando você quer <strong>levar pessoas para o seu site ou WhatsApp</strong>.
                        </p>
                        <ul>
                            <li>✅ <strong>Quando usar:</strong> Divulgar promoções, agendar horários, mostrar serviços</li>
                            <li>📱 <strong>Resultado:</strong> Mais cliques no link do seu anúncio</li>
                            <li>💰 <strong>Custo:</strong> Você paga por cada clique recebido</li>
                        </ul>
                        <p className="mb-0">
                            <strong>Exemplo prático:</strong> "Agende seu horário agora! Clique e fale conosco no WhatsApp"
                        </p>
                    </div>
                );
    
            case 'OUTCOME_AWARENESS': // antes REACH / BRAND_AWARENESS (mesma explicação)
                return (
                    <div className="p-3 border rounded bg-light">
                        <h6 className="fw-bold">📢 O que é Alcance?</h6>
                        <p>
                            Este objetivo faz seu anúncio <strong>aparecer para o máximo de pessoas possível</strong>.
                        </p>
                        <ul>
                            <li>✅ <strong>Quando usar:</strong> Divulgar inauguração, novos serviços, eventos especiais</li>
                            <li>👥 <strong>Resultado:</strong> Muitas pessoas veem seu anúncio</li>
                            <li>💰 <strong>Custo:</strong> Você paga por cada mil pessoas alcançadas</li>
                        </ul>
                        <p className="mb-0">
                            <strong>Exemplo prático:</strong> "Novo salão na região! Conheça nossos serviços"
                        </p>
                    </div>
                );
    
            case 'OUTCOME_LEADS': // antes LEAD_GENERATION
                return (
                    <div className="p-3 border rounded bg-light">
                        <h6 className="fw-bold">📋 O que é Geração de leads?</h6>
                        <p>
                            Este objetivo <strong>coleta dados de clientes interessados</strong> (nome, telefone, email).
                        </p>
                        <ul>
                            <li>✅ <strong>Quando usar:</strong> Captar novos clientes, criar lista de contatos</li>
                            <li>📝 <strong>Resultado:</strong> Formulário preenchido direto no Facebook/Instagram</li>
                            <li>💰 <strong>Custo:</strong> Você paga por cada formulário enviado</li>
                        </ul>
                        <p className="mb-0">
                            <strong>Exemplo prático:</strong> "Ganhe 20% OFF no primeiro atendimento! Cadastre-se"
                        </p>
                    </div>
                );
    
            case 'OUTCOME_ENGAGEMENT': // antes MESSAGES
                return (
                    <div className="p-3 border rounded bg-light">
                        <h6 className="fw-bold">💬 O que é Mensagens?</h6>
                        <p>
                            Este objetivo incentiva as pessoas a <strong>conversarem com você no Messenger ou WhatsApp</strong>.
                        </p>
                        <ul>
                            <li>✅ <strong>Quando usar:</strong> Tirar dúvidas, agendar horários, atendimento direto</li>
                            <li>💬 <strong>Resultado:</strong> Conversas iniciadas com clientes</li>
                            <li>💰 <strong>Custo:</strong> Você paga por cada mensagem recebida</li>
                        </ul>
                        <p className="mb-0">
                            <strong>Exemplo prático:</strong> "Dúvidas sobre nossos serviços? Mande uma mensagem!"
                        </p>
                    </div>
                );
    
            case 'OUTCOME_SALES': // antes CONVERSIONS
                return (
                    <div className="p-3 border rounded bg-light">
                        <h6 className="fw-bold">🎯 O que é Conversões?</h6>
                        <p>
                            Este objetivo busca pessoas que <strong>realmente vão agendar ou comprar</strong>.
                        </p>
                        <ul>
                            <li>✅ <strong>Quando usar:</strong> Vender produtos, agendar serviços online</li>
                            <li>🎯 <strong>Resultado:</strong> Ações concretas (compras, agendamentos)</li>
                            <li>💰 <strong>Custo:</strong> Otimizado para quem tem maior chance de converter</li>
                            <li>⚠️ <strong>Requer:</strong> Pixel do Facebook instalado no site</li>
                        </ul>
                        <p className="mb-0">
                            <strong>Exemplo prático:</strong> "Agende seu horário online agora com desconto!"
                        </p>
                    </div>
                );
    
            case 'gender':
                return (
                    <div className="p-3 border rounded bg-light">
                        <h6 className="fw-bold">👥 O que é Segmentação por Gênero?</h6>
                        <p>
                            A <strong>segmentação por gênero</strong> permite que você escolha se seu anúncio será exibido para <strong>homens, mulheres ou ambos</strong>.
                        </p>
    
                        <h6 className="fw-bold mt-3">Como funciona?</h6>
                        <ul>
                            <li>👨 <strong>Homens:</strong> Anúncio exibido apenas para público masculino</li>
                            <li>👩 <strong>Mulheres:</strong> Anúncio exibido apenas para público feminino</li>
                            <li>👥 <strong>Todos:</strong> Anúncio exibido para homens e mulheres</li>
                        </ul>
    
                        <h6 className="fw-bold mt-3">Quando usar cada opção?</h6>
                        <div className="p-2 bg-white rounded mb-2">
                            <strong>👨 Homens - Exemplos:</strong>
                            <p className="mb-0 small">• Corte masculino<br />• Barba e bigode<br />• Tratamentos capilares masculinos</p>
                        </div>
                        <div className="p-2 bg-white rounded mb-2">
                            <strong>👩 Mulheres - Exemplos:</strong>
                            <p className="mb-0 small">• Manicure e pedicure<br />• Coloração e mechas<br />• Depilação<br />• Maquiagem</p>
                        </div>
                        <div className="p-2 bg-white rounded">
                            <strong>👥 Todos - Exemplos:</strong>
                            <p className="mb-0 small">• Promoções gerais do salão<br />• Hidratação capilar<br />• Massagem relaxante<br />• Dia de beleza</p>
                        </div>
    
                        <div className="alert alert-info mt-3 mb-0" style={{ fontSize: '14px' }}>
                            <strong>💡 Dica:</strong> Segmentar por gênero aumenta a relevância do anúncio e melhora os resultados!
                        </div>
                    </div>
                );
    
            case 'amount_spent':
                return (
                    <div className="p-3 border rounded bg-light">
                        <h6 className="fw-bold">💰 O que é o Orçamento Diário?</h6>
                        <p>
                            O <strong>orçamento diário</strong> é o <strong>valor máximo que você quer gastar por dia</strong> com seu anúncio.
                        </p>
    
                        <h6 className="fw-bold mt-3">Como funciona?</h6>
                        <ul>
                            <li>💵 <strong>Valor mínimo:</strong> R$ 1,00 por dia</li>
                            <li>📅 <strong>Controle total:</strong> O Facebook nunca vai gastar mais que o valor definido</li>
                            <li>⏰ <strong>Distribuição:</strong> O valor é gasto ao longo do dia de forma otimizada</li>
                            <li>🎯 <strong>Flexibilidade:</strong> Você pode pausar ou ajustar a qualquer momento</li>
                        </ul>
    
                        <h6 className="fw-bold mt-3">Exemplos práticos:</h6>
                        <div className="p-2 bg-white rounded mb-2">
                            <strong>📊 R$ 10,00/dia por 7 dias = R$ 70,00 total</strong>
                            <p className="mb-0 small text-muted">Ideal para testar e ver os primeiros resultados</p>
                        </div>
                        <div className="p-2 bg-white rounded mb-2">
                            <strong>📊 R$ 30,00/dia por 15 dias = R$ 450,00 total</strong>
                            <p className="mb-0 small text-muted">Bom alcance para divulgar promoções</p>
                        </div>
                        <div className="p-2 bg-white rounded">
                            <strong>📊 R$ 50,00/dia por 30 dias = R$ 1.500,00 total</strong>
                            <p className="mb-0 small text-muted">Campanha robusta para crescimento constante</p>
                        </div>
    
                        <div className="alert alert-info mt-3 mb-0" style={{ fontSize: '14px' }}>
                            <strong>💡 Dica:</strong> Comece com valores menores (R$ 10-20/dia) para testar.
                            Depois de ver os resultados, você pode aumentar o investimento!
                        </div>
                    </div>
                );
    
            case 'campaign_dates':
                return (
                    <div className="p-3 border rounded bg-light">
                        <h6 className="fw-bold">📅 O que são as Datas da Campanha?</h6>
                        <p>
                            As <strong>datas de início e término</strong> definem <strong>quando seu anúncio vai estar ativo</strong>.
                        </p>
    
                        <h6 className="fw-bold mt-3">Como funciona?</h6>
                        <ul>
                            <li>🚀 <strong>Data de início:</strong> Quando o anúncio começa a ser exibido</li>
                            <li>🏁 <strong>Data de término:</strong> Quando o anúncio para automaticamente</li>
                            <li>⏰ <strong>Horário:</strong> Você pode escolher hora específica para começar/terminar</li>
                            <li>⚡ <strong>Imediato:</strong> Pode começar agora mesmo ou agendar para depois</li>
                        </ul>
    
                        <h6 className="fw-bold mt-3">Exemplos práticos:</h6>
                        <div className="p-2 bg-white rounded mb-2">
                            <strong>📊 Promoção de fim de semana</strong>
                            <p className="mb-0 small text-muted">Sexta 18h até Domingo 23h59</p>
                        </div>
                        <div className="p-2 bg-white rounded mb-2">
                            <strong>📊 Campanha mensal</strong>
                            <p className="mb-0 small text-muted">Dia 1 às 00h até dia 30 às 23h59</p>
                        </div>
                        <div className="p-2 bg-white rounded">
                            <strong>📊 Black Friday</strong>
                            <p className="mb-0 small text-muted">24/11 às 00h até 27/11 às 23h59</p>
                        </div>
    
                        <div className="alert alert-info mt-3 mb-0" style={{ fontSize: '14px' }}>
                            <strong>💡 Dica:</strong> Campanhas mais longas (15-30 dias) permitem que o Facebook
                            otimize melhor os resultados ao longo do tempo!
                        </div>
                    </div>
                );
    
            case 'age_range':
                return (
                    <div className="p-3 border rounded bg-light">
                        <h6 className="fw-bold">👥 O que é a Faixa Etária?</h6>
                        <p>
                            A <strong>faixa etária</strong> define <strong>qual idade das pessoas</strong> que vão ver seu anúncio.
                        </p>
    
                        <h6 className="fw-bold mt-3">Como funciona?</h6>
                        <ul>
                            <li>🔢 <strong>Idade mínima:</strong> A partir de 13 anos (regra do Facebook)</li>
                            <li>🔢 <strong>Idade máxima:</strong> Até 65+ anos</li>
                            <li>🎯 <strong>Segmentação:</strong> Quanto mais específico, melhor o resultado</li>
                            <li>💰 <strong>Custo:</strong> Públicos muito amplos podem custar mais</li>
                        </ul>
    
                        <h6 className="fw-bold mt-3">Exemplos práticos para salões:</h6>
                        <div className="p-2 bg-white rounded mb-2">
                            <strong>📊 Público jovem (18-30 anos)</strong>
                            <p className="mb-0 small text-muted">Ideal para: Cortes modernos, coloração, nail art</p>
                        </div>
                        <div className="p-2 bg-white rounded mb-2">
                            <strong>📊 Público adulto (30-50 anos)</strong>
                            <p className="mb-0 small text-muted">Ideal para: Tratamentos capilares, spa, estética facial</p>
                        </div>
                        <div className="p-2 bg-white rounded">
                            <strong>📊 Público maduro (50-65+ anos)</strong>
                            <p className="mb-0 small text-muted">Ideal para: Hidratação, tratamentos anti-idade, massagens</p>
                        </div>
    
                        <div className="alert alert-info mt-3 mb-0" style={{ fontSize: '14px' }}>
                            <strong>💡 Dica:</strong> Pense no perfil dos seus clientes atuais!
                            Se a maioria tem entre 25-45 anos, use essa faixa no anúncio.
                        </div>
                    </div>
                );
    
            default:
                return null;
        }
    };
    

    const formatOptionLabel = (option) => {
        return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <span style={{ fontSize: '20px' }}>{option.icon}</span>
                <span style={{ fontWeight: 600 }}>{option.label}</span>
            </div>
        );
    };

    return (
        <div className="budget-section">
            <h4 className="create-ad-section-title">💰 Orçamento e Público</h4>

            <p className="section-description">
                Configure quanto deseja investir, o período da campanha e quem você quer alcançar.
            </p>

            <Row>
                <Col xs={12} md={6}>
                    <div style={{ marginBottom: '20px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                            <label className="field-label" style={{ margin: 0 }}>
                                Objetivo da Campanha <span className="required">*</span>
                            </label>
                            <button
                                type="button"
                                className="info-button"
                                onClick={() => openInfoModal(values.objective)}
                                title="Clique para entender cada objetivo"
                            >
                                <FontAwesomeIcon icon={faInfoCircle} />
                            </button>
                        </div>
                        <Select
                            isDisabled={isEdit}
                            styles={customStyles}
                            options={objectiveOptions}
                            value={objectiveOptions.find(opt => opt.value === values.objective)}
                            onChange={(selected) => setFieldValue('objective', selected?.value || '')}
                            formatOptionLabel={formatOptionLabel}
                            isSearchable={false}
                        />
                        <small className="field-hint">
                            💡 Clique no ícone <FontAwesomeIcon icon={faInfoCircle} /> para entender cada objetivo
                        </small>
                    </div>
                </Col>

                <Col xs={12} md={6}>
                    <div style={{ marginBottom: '20px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                            <label className="field-label" style={{ margin: 0 }}>
                                Valor a ser gasto por dia <span className="required">*</span>
                            </label>
                            <button
                                type="button"
                                className="info-button"
                                onClick={() => openInfoModal('amount_spent')}
                                title="Clique para entender o orçamento diário"
                            >
                                <FontAwesomeIcon icon={faInfoCircle} />
                            </button>
                        </div>
                        <AppCurrencyInput
                            isRequired
                            label="Orçamento Diário"
                            value={values.dailyBudget}
                            onChange={(_, value) => setFieldValue('dailyBudget', value)}
                            errors={errors}
                            touched={touched}
                        />
                        <small className="field-hint">
                            💡 Clique no ícone <FontAwesomeIcon icon={faInfoCircle} /> para ver exemplos
                        </small>
                    </div>
                </Col>
            </Row>


            <Row>
                <Col xs={12}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px' }}>
                        <h6 className="field-label" style={{ margin: 0, fontSize: '16px' }}>
                            📅 Período da Campanha
                        </h6>
                        <button
                            type="button"
                            className="info-button"
                            onClick={() => openInfoModal('campaign_dates')}
                            title="Clique para entender as datas"
                        >
                            <FontAwesomeIcon icon={faInfoCircle} />
                        </button>
                    </div>
                </Col>
            </Row>

            <Row>
                <Col xs={12} md={6}>
                    <AppDateTimeInput
                        isRequired
                        name="startDate"
                        label="Data de Início"
                        value={values.startDate}
                        onChange={handleChange}
                        errors={errors}
                        touched={touched}
                        minDate={new Date()}
                        placeholder="DD/MM/YYYY HH:MM"
                    />
                </Col>

                <Col xs={12} md={6}>
                    <AppDateTimeInput
                        isRequired
                        name="endDate"
                        label="Data de Término"
                        value={values.endDate}
                        onChange={handleChange}
                        errors={errors}
                        touched={touched}
                        minDate={values.startDate ? new Date(values.startDate) : new Date()}
                        placeholder="DD/MM/YYYY HH:MM"
                    />
                </Col>
            </Row>
            {/* Campo de Gênero */}
            <Row style={{ marginTop: '20px' }}>
                <Col xs={12}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px' }}>
                        <h6 className="field-label" style={{ margin: 0, fontSize: '16px' }}>
                            👥 Gênero do Público <span className="required">*</span>
                        </h6>
                        <button
                            type="button"
                            className="info-button"
                            onClick={() => openInfoModal('gender')}
                            title="Clique para entender a segmentação por gênero"
                        >
                            <FontAwesomeIcon icon={faInfoCircle} />
                        </button>
                    </div>

                    <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                        <button
                            type="button"
                            onClick={() => handleGenderChange('male')}
                            style={{
                                flex: '1 1 150px',
                                padding: '16px',
                                border: selectedGender === 'male' ? '3px solid #4A90E2' : '2px solid #e9ecef',
                                borderRadius: '10px',
                                background: selectedGender === 'male' ? '#e8f4fd' : 'white',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                gap: '8px'
                            }}
                        >
                            <span style={{ fontSize: '32px' }}>👨</span>
                            <strong style={{ fontSize: '16px', color: '#2c3e50' }}>Homens</strong>
                            <small style={{ color: '#5a6c7d', fontSize: '13px' }}>Apenas público masculino</small>
                        </button>

                        <button
                            type="button"
                            onClick={() => handleGenderChange('female')}
                            style={{
                                flex: '1 1 150px',
                                padding: '16px',
                                border: selectedGender === 'female' ? '3px solid #E91E63' : '2px solid #e9ecef',
                                borderRadius: '10px',
                                background: selectedGender === 'female' ? '#fce4ec' : 'white',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                gap: '8px'
                            }}
                        >
                            <span style={{ fontSize: '32px' }}>👩</span>
                            <strong style={{ fontSize: '16px', color: '#2c3e50' }}>Mulheres</strong>
                            <small style={{ color: '#5a6c7d', fontSize: '13px' }}>Apenas público feminino</small>
                        </button>

                        <button
                            type="button"
                            onClick={() => handleGenderChange('all')}
                            style={{
                                flex: '1 1 150px',
                                padding: '16px',
                                border: selectedGender === 'all' ? '3px solid #667eea' : '2px solid #e9ecef',
                                borderRadius: '10px',
                                background: selectedGender === 'all' ? '#f0f2ff' : 'white',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                gap: '8px'
                            }}
                        >
                            <span style={{ fontSize: '32px' }}>👥</span>
                            <strong style={{ fontSize: '16px', color: '#2c3e50' }}>Todos</strong>
                            <small style={{ color: '#5a6c7d', fontSize: '13px' }}>Homens e mulheres</small>
                        </button>
                    </div>

                    <small className="field-hint" style={{ display: 'block', marginTop: '8px', color: '#5a6c7d', fontSize: '14px' }}>
                        💡 Escolha o gênero do público que você quer atingir com este anúncio
                    </small>
                </Col>
            </Row>

            <Row style={{ marginTop: '20px' }}>
                <Col xs={12}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px' }}>
                        <h6 className="field-label" style={{ margin: 0, fontSize: '16px' }}>
                            👥 Faixa Etária do Público
                        </h6>
                        <button
                            type="button"
                            className="info-button"
                            onClick={() => openInfoModal('age_range')}
                            title="Clique para entender a faixa etária"
                        >
                            <FontAwesomeIcon icon={faInfoCircle} />
                        </button>
                    </div>
                </Col>
            </Row>

            <Row>
                <Col xs={6} md={6}>
                    <AppInput
                        isRequired
                        name="ageMin"
                        label="Idade Mínima"
                        type="number"
                        value={values.ageMin}
                        onChange={handleChange}
                        errors={errors}
                        touched={touched}
                    />
                </Col>

                <Col xs={6} md={6}>
                    <AppInput
                        isRequired
                        name="ageMax"
                        label="Idade Máxima"
                        type="number"
                        value={values.ageMax}
                        onChange={handleChange}
                        errors={errors}
                        touched={touched}
                    />
                </Col>
            </Row>

            {/* Modal Informativo */}
            {showInfoModal && (
                <InformativeModal
                    show={showInfoModal}
                    closeModal={closeInfoModal}
                >
                    {buildInfoByObjective()}
                </InformativeModal>
            )}
        </div>
    );
}

export default BudgetSection;